import { parseStripeReturn } from "@froppio/host-auth";
import { Link } from "react-router-dom";
import { navigationState } from "@/core/routing/navigationPolicy";
import { Button } from "@/shared/components/shadcn/Button";
import { ErrorState } from "@/shared/components/ui/ErrorState";
import { Page, PageContent } from "@/shared/components/ui/Page";
import { PageHeader } from "@/shared/components/ui/PageHeader";
import { Section } from "@/shared/components/ui/Section";

export function StripeReturnPage() {
  const result = parseStripeReturn(window.location.href, window.location.origin, !import.meta.env.DEV);
  return <Page><PageHeader title="Return from Stripe" /><PageContent>
    <Section title="Check your Stripe connection" card>
      <p className="text-sm text-muted-foreground">Once payment collection is enabled and Stripe approves your account, open an appointment and choose Charge.</p>
      {!result ? <ErrorState message="This Stripe return link is invalid. Reopen Froppio and check Stripe settings." /> : <>
        <p role="status">{result.outcome === "expired" ? "This setup link expired. Check your status in Froppio and continue setup if needed." :
          result.outcome === "error" ? "Stripe setup could not finish. Check your status in Froppio and try again." :
          "You returned from Stripe. This does not confirm completion. Froppio must check your account status."}</p>
        {result.channel === "native" ? <>
          <p>Return to the Froppio app to check your status. No browser sign-in is needed.</p>
          <p>If the app did not open, reopen Froppio manually and select More → Stripe, then Refresh.</p>
        </> : <Button asChild>
          <Link to={`/b/${result.businessId}/l/${result.locationId}/stripe`} state={navigationState("start")}>Check Stripe status in Froppio</Link>
        </Button>}
      </>}
    </Section>
  </PageContent></Page>;
}
